
import { BaseVue } from "@newview/base-web";
import searchCom from "./searchCom.vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { FilterHelper } from "@newview/tools";
declare let $: any;
@Component({
  name: "grid",
  components: {
    searchCom,
  },
  computed: {},
})
export default class grid extends BaseVue {
  @Prop({ default: "" })
  operates!: any; // 模块按钮权限列表
  gridBoxId = "gridBox_" + this.NewGuid();
  gridEleId = "grid_" + this.NewGuid();
  defaultColWidth = "50px";
  CheckedRowArray: any = []; //被勾选的行的数据集合
  @Prop({ default: "view" })
  gridType!: String; //表格类型('view'只读，'edit'行内编辑)
  @Prop({ default: false })
  notCtrlBtn!: Boolean; //不控制按钮显示(true:不控制，false:控制)
  @Prop({ default: true })
  isToolBar!: Boolean; //是否显示上方工具栏按钮
  @Prop({ default: true })
  isShowAdd!: Boolean; //是否显示添加按钮
  @Prop({ default: true })
  isShowRefresh!: Boolean; //是否显示刷新按钮
  @Prop({ default: true })
  isShowSave!: Boolean; //是否显示保存按钮
  @Prop({ default: false })
  isShowSearch!: Boolean; //是否显示搜索按钮
  @Prop({ default: () => [] })
  toolBarCustom!: []; //自定义工具栏按钮列表
  @Prop({ default: "calc(100% - 65px)" })
  gridBoxHeight!: String; //表格高度
  @Prop({ default: null }) gridMaxHeight!: any; //表格最大高度

  @Prop({ default: false })
  loading!: Boolean; //表格是否处于加载中状态
  @Prop({ default: true })
  isPagination!: Boolean; //是否显示分页组件
  @Prop({ default: () => ({ total: 0, pageSize: 25, elevator: true }) })
  paginationSetting: Object | undefined; //分页参数
  @Prop({ default: () => [] })
  ColConfig!: Array<any>; //列配置参数
  @Prop({ default: true })
  isSelectRow!: Boolean; //是否高亮选中某行
  @Prop({ default: () => [] })
  gridData!: Array<any>; //表格数据
  @Prop({ default: "Id" })
  rowKey!: String; //表格数据
  @Prop({ default: () => ({}) })
  searchSetting?: any; //搜索条件配置参数
  @Prop({ default: () => ({}) })
  toolBarClick: any | undefined; //默认工具栏点击事件
  @Prop({ default: () => ({}) })
  rowOperation: any | undefined; //表格行内操作列配置参数
  @Prop({ default: false })
  showSummary!: boolean; // 显示合计
  @Prop({ default: () => ({}) })
  summaryMethod!: Function; // 合计方法
  @Prop({ default: () => 150 })
  handelColWidth!: number;
  @Prop({ default: "" })
  delMsgKey!: any; //删除提示语对应列的key
  @Prop({ default: null }) rowClassNameCustom!: any;

  rowOperationNew: any;
  gridBoxHeightNow = this.gridBoxHeight;
  heightnum: any = 0; //表格具体高度（数字）
  searchDisplay = "none"; //搜索框默认隐藏
  currentRow: any = {};
  editData: any = [];
  addData: Array<object> = [];
  chKey = "";
  allCheckValue = false; //表头全选框值
  rowClassName(row, index) {
    if (this.rowClassNameCustom) {
      return this.rowClassNameCustom(row, index);
    } else {
      if (row.itemId && (!row.Id || row.Id == 0)) {
        return "ivu-grid-new-row";
      } else {
        if (row.rowIsSelected) {
          return "ivu-table-row-highlight";
        } else {
          return "";
        }
      }
    }
  }
  mounted() {
    let $this = this;
    //表格行内操作列配置参数 (合并重新赋值)
    this.rowOperationNew = $.extend(
      {
        title: "操作",
        isShow: true,
        cellW: this.handelColWidth,
        isEditBtn: true,
        isDelBtn: true,
        otherBtn: [],
      },
      this.rowOperation
    );
    setTimeout(() => {
      this.heightnum = $("#" + $this.gridEleId).height();
      if (this.gridBoxHeight == "auto") {
        this.heightnum = undefined;
      }
    }, 100);
    this.editData = JSON.parse(JSON.stringify(this.gridData));
    this.initEditGrid();
  }
  // 监听gridData改变
  @Watch("CheckedRowArray")
  CheckedRowArrayChange() {
    if (this.CheckedRowArray.length == 0) {
      this.allCheckValue = false;
    } else if (this.CheckedRowArray.length != this.editData.length) {
      this.allCheckValue = false;
    } else if (this.CheckedRowArray.length == this.editData.length) {
      this.allCheckValue = true;
    }
  }
  // 监听gridData改变
  @Watch("gridData")
  gridDataChange() {
    this.editData = JSON.parse(JSON.stringify(this.gridData));
    // this.editData = this.gridData
  }
  initEditGrid() {
    let $this = this;
    this.ColConfig.push({
      title: "",
      key: "DefaultCh",
      width: 1,
      render: (h, params) => {
        return h("div", [
          h(
            "Checkbox",
            {
              props: {
                value: true,
              },
              on: {
                input: function (event) {},
              },
              style: {
                display: "none",
              },
            },
            ""
          ),
        ]);
      },
    });
    this.ColConfig.forEach(function (item, index) {
      // item.renderHeader = (h, params) => {
      //   return h("div", { style: "width:100%;text-align:center;" }, item.title);
      // };
      if (item.colType) {
        switch (item.colType) {
          //ch
          case "ch":
            $this.chKey = item.key;
            item.align = "center";
            item.width = 50;
            if (item.IsAll) {
              item.renderHeader = (h, params) => {
                return h("div", { style: "width:100%;text-align:center;" }, [
                  h(
                    "Checkbox",
                    {
                      props: {
                        value: $this.allCheckValue,
                      },
                      on: {
                        input: function (event) {
                          $this.checkedAll(event);
                        },
                      },
                    }
                    // item.title
                  ),
                ]);
              };
            }
            item.render = (h, params: any) => {
              let chDisabl = false;
              if (
                (item.noCheckLev && params.row._treeLevel == item.noCheckLev) ||
                params.row._disabled
              ) {
                chDisabl = true;
              }
              // if(params.row._disabled){
              //   chDisabl=true;
              // }
              return h(
                "Checkbox",
                {
                  props: {
                    value: params.row[item.key],
                    disabled: chDisabl,
                  },
                  on: {
                    input: function (event) {
                      let id = params.row.Id?params.row.Id:(params.row.id?params.row.id:params.row.itemId)
                      $this.checkedRows(
                        // params.row.Id ? params.row.Id : params.row.itemId,
                        id,
                        event
                      );
                      // $this.$emit("on-check", params.row, event);
                    },
                  },
                },
                ""
              );
            };
            break;
          //文本
          case "ed":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                return h("Input", {
                  props: {
                    value: params.row[item.key],
                  },
                  on: {
                    input: function (event) {
                      params.row[item.key] = event;
                      // $this.$set(params.row, params.row[item.key], event)
                      $this.setData(params.row, item.key, event);
                    },
                  },
                });
              } else {
                return h("span", params.row[item.key]);
              }
            };
            break;
          //数字
          case "num":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                let props = $.extend(item.otherParam, {
                  value: params.row[item.key],
                });
                return h("InputNumber", {
                  props: props,
                  on: {
                    input: function (event) {
                      params.row[item.key] = event;
                      $this.setData(params.row, item.key, event);
                    },
                  },
                });
              } else {
                return h("span", params.row[item.key]);
              }
            };
            break;
          //日期选择
          case "date":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                let format = item.otherParam
                  ? item.otherParam.format
                  : "yyyy-MM-dd";
                return h("DatePicker", {
                  props: {
                    value: params.row[item.key],
                    type: item.otherParam ? item.otherParam.type : "date",
                    transfer: true,
                  },
                  on: {
                    input: function (event) {
                      params.row[item.key] =
                        event == "" ? event : $this.ForMatDate(event, format);
                      $this.setData(
                        params.row,
                        item.key,
                        event == "" ? event : $this.ForMatDate(event, format)
                      );
                    },
                  },
                });
              } else {
                // return h("span", params.row[item.key]);
                return h(
                  "span",
                  item.format ? item.format(params.row) : params.row[item.key]
                );
              }
            };
            break;
          //时间选择
          case "time":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                let format = item.otherParam
                  ? item.otherParam.format
                  : "HH:mm:ss";
                return h("TimePicker", {
                  props: {
                    transfer:true,
                    value: params.row[item.key],
                    type: item.otherParam ? item.otherParam.type : "time",
                  },
                  on: {
                    input: function (event) {
                      params.row[item.key] = event == "" ? event : event;
                      $this.setData(
                        params.row,
                        item.key,
                        event == "" ? event : event
                      );
                    },
                  },
                });
              } else {
                // return h("span", params.row[item.key]);
                return h(
                  "span",
                  item.format ? item.format(params.row) : params.row[item.key]
                );
              }
            };
            break;
          //下拉列表
          case "select":
          case "selelct":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                let sels: any = [];
                item.selectData.forEach(function (selItem, index) {
                  sels.push(
                    h(
                      "Option",
                      {
                        props: {
                          value: selItem.value,
                        },
                      },
                      selItem.text
                    )
                  );
                });
                return h(
                  "Select",
                  {
                    props: {
                      transfer:true,
                      filterable: item.filterable ? item.filterable : false,
                      value: params.row[item.key],
                    },
                    on: {
                      input: function (event) {
                        console.log(event);
                        params.row[item.key] = event;
                        $this.setData(params.row, item.key, event);
                      },
                      "on-change": (e) => {
                        $this.$emit("selecte", e, item.key, params.row, item);
                        // console.log(e)// 改变下拉框赋值
                         if (item.onChange) item.onChange(e,params.row,item);
                      },
                    },
                  },
                  sels
                );
              } else {
                return h(
                  "div",
                  FilterHelper.sysDicFilter(
                    params.row[item.key],
                    item.selectData
                  )
                );
              }
            };
            break;
          //自定义编辑
          case "custom":
            item.render = (h, params) => {
              if (params.row.$isEdit) {
                return item.editEvent(h, params);
              } else {
                return item.defaultEvent(h, params);
              }
            };
            break;
          default:
            if (!item.render) {
              item.render = (h, params) => {
                let value = item.format
                  ? item.format(params.row)
                  : params.row[item.key];
                return h("span", { title: value }, value);
              };
            }
            break;
        }
      } else {
        if (!item.render && item.format) {
          item.render = (h, params) => {
            let value = item.format(params.row);
            return h("span", { title: value }, value);
          };
        }
      }
    });
    //操作列
    if (this.rowOperationNew.isShow) {
      let isShowOpCol = false;
      if (
        this.rowOperationNew.isEditBtn ||
        this.rowOperationNew.isDelBtn ||
        (this.rowOperationNew.otherBtn &&
          this.rowOperationNew.otherBtn.length > 0)
      ) {
        if (
          this.btnIsShow("Edit", this.operates) ||
          this.btnIsShow("Clear", this.operates)
        ) {
          isShowOpCol = true;
        }
        for (let otherbtnitem of this.rowOperationNew.otherBtn) {
          if (this.btnIsShow(otherbtnitem.code, this.operates)) {
            isShowOpCol = true;
          }
        }
        if (this.notCtrlBtn) {
          isShowOpCol = true;
        }
      }
      if (isShowOpCol) {
        /*S 根据Title判断是否存在相同列，防止重复添加操作列，可能有Bug S*/
        let flg: boolean = false;
        this.ColConfig.forEach((value, index) => {
          if (value.title == this.rowOperationNew.title) {
            flg = true;
          }
        });
        if (flg) {
          return;
        }
        /*E E*/
        this.ColConfig.push({
          title: this.rowOperationNew.title,
          fixed: "right",
          slot: "action",
          width: this.rowOperationNew.cellW,
          align: "center",
          render: (h, params) => {
            let rowbtns: any = [];
            if (this.rowOperationNew.isEditBtn) {
              if (
                this.btnIsShow(this.notCtrlBtn ? "-" : "Edit", this.operates)
              ) {
                rowbtns.push(
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      class: "grid-row-btn theme-color",
                      on: {
                        click: () => {
                          if (this.gridType == "view") {
                            this.rowOperationNew.editRowEvent(params.row);
                          } else {
                            if (params.row.$isEdit) {
                              // 是否编辑
                              this.handleHold(params.row);
                            } else {
                              this.handleEdit(params.row);
                            }
                          }
                        },
                      },
                    },
                    params.row.$isEdit ? "取消" : "编辑"
                  )
                );
              }
            }
            if (this.rowOperationNew.isDelBtn) {
              if (
                this.btnIsShow(this.notCtrlBtn ? "-" : "Clear", this.operates)
              ) {
                rowbtns.push(
                  h(
                    "Button",
                    {
                      props: {
                        type: "text",
                        size: "small",
                      },
                      class: "grid-row-btn theme-color",
                      on: {
                        click: () => {
                          this.deleteClickRow(params.row);
                        },
                      },
                    },
                    "删除"
                  )
                );
              }
            }
            if (
              this.rowOperationNew.otherBtn &&
              this.rowOperationNew.otherBtn.length > 0
            ) {
              this.rowOperationNew.otherBtn.forEach(function (item, index) {
                if (
                  $this.btnIsShow(
                    $this.notCtrlBtn ? "-" : item.code,
                    $this.operates
                  )
                ) {
                  rowbtns.push(
                    h(
                      "Button",
                      {
                        props: {
                          type: "text",
                          size: "small",
                        },
                        class: "grid-row-btn theme-color",
                        on: {
                          click: () => {
                            item.clickEvent(params.row);
                          },
                        },
                      },
                      item.name
                    )
                  );
                }
              });
            }
            return h("div", rowbtns);
          },
        });
      }
    }
  }
  //选中某行触发事件
  RowCurrentEvent(currentRow, oldcurrentRow) {
    this.currentRow = currentRow;
    this.$emit("row-selected", currentRow, oldcurrentRow);
  }
  RowClickEvent(row, index) {
    this.$emit("row-click", row, index);
  }
  RowdbClickEvent(row, index) {
    this.$emit("row-dbclick", row, index);
    //双击事件
  }
  selectEvent(selection, row) {}
  selectALLEvent(selection) {}
  selectChangeEvent(selection) {
    this.$emit("sel-Change", selection);
  }
  /**
   * @description: 设置行选中状态
   * @param {*} row  选中行数据
   * @param {*} key  比对key
   * @return {*}
   */
  setRowIsSelected(row, key = "Id") {
    for (const item of this.editData) {
      if (row[key] == item[key]) {
        this.$set(item, "rowIsSelected", true);
      } else {
        this.$set(item, "rowIsSelected", false);
      }
    }
  }
  pageChange(num: Number) {
    console.log(num);
  }
  handleEdit(row) {
    this.$set(row, "$isEdit", true);
  }
  handleHold(row) {
    this.$set(row, "$isEdit", false);
  }
  closeEdit(row){
     let _this = this;
    this.editData.forEach(function (item: any, index) {
      let id = row.Id ? "Id" : row.id ? "id" : "itemId";
      if (item[id] == row[id]) {
        _this.$set(item, "$isEdit", false);
      }
    });
  }
  setData(row, key, currentValue) {
    let _this = this;
    this.editData.forEach(function (item: any, index) {
      let id = row.Id ? "Id" : row.id ? "id" : "itemId";
      if (item[id] == row[id]) {
        console.log(key);
        _this.$set(item, "$isEdit", true);
        _this.$set(item, key, currentValue);
        _this.$set(item, "isChange", true);
      }
    });
  }

  //搜索框隐藏/显示
  searchToggle() {
    if (this.searchDisplay == "none") {
      this.searchDisplay = "block";
      let searchH = $("#" + this.gridBoxId + " .searchDiv").height();
      this.gridBoxHeightNow = this.heightnum - searchH + "px";
      this.heightnum = this.heightnum - searchH;
    } else {
      let searchH = $("#" + this.gridBoxId + " .searchDiv").height();
      this.searchDisplay = "none";
      this.gridBoxHeightNow = this.gridBoxHeight;
      this.heightnum = this.heightnum + searchH;
    }
  }

  searchFun(param) {
    let keyword = "";
    let searchParam = "";
    for (const key in param) {
      if (!this.isNull(param[key])) {
        searchParam += key + " like '%" + param[key] + "%' and ";
        keyword += param[key];
      }
    }
    searchParam = searchParam.substring(0, searchParam.length - 5);
    if (searchParam.length == 0) {
      searchParam = "1 = 1";
    }
    this.$emit("on-search", searchParam, param, keyword.toString());
  }

  addFun() {
    if (this.gridType == "view") {
      this.toolBarClick.addFun();
    } else {
      if (this.toolBarClick.addFun) {
        this.toolBarClick.addFun();
      } else {
        this.addRowFun();
      }
    }
  }
  addRowFun(addData: any = {}) {
    addData.$isEdit = true;
    addData.itemId = this.NewGuid();
    addData.isChange = true;

    // this.editData.push(addData);

    this.editData.unshift(addData);
  }
  saveEdit() {
    let data: any = [];
    this.editData.forEach(function (item: any, index) {
      if (item.isChange) {
        data.push(item);
      }
    });
    if (data.length == 0) {
      this.warning("您还未添加或修改任何数据！");
      return;
    }
    return data;
  }
  //保存方法
  saveFun() {
    let data: any = [];
    this.editData.forEach(function (item: any, index) {
      if (item.isChange) {
        data.push(item);
      }
    });
    if (data.length == 0) {
      this.warning("您还未添加或修改任何数据！");
      return;
    }
    this.toolBarClick.saveFun(data, this.editData);
  }
  getGridEditData(isAll = false) {
    let data: any = [];
    this.editData.forEach(function (item: any, index) {
      if (isAll) {
        data.push(item);
      } else {
        if (item.isChange) {
          data.push(item);
        }
      }
    });
    return data;
  }
  deleteClickRow(row) {
    let _this = this;
    if ((this.rowOperationNew.delRowEvent && row.Id) || row.id) {
      this.confirm(
        "确定要删除" +
          (row[this.delMsgKey] ? row[this.delMsgKey] : "该条数据") +
          "吗?",
        () => {
          this.rowOperationNew.delRowEvent(row);
        }
      );
    } else {
      this.delRow(row);
    }
  }
  delRow(row) {
    this.editData.forEach((item: any, index) => {
      let id = "id";
      if (item.Id != undefined) {
        id = "Id";
      }
      if (item.itemId != undefined) {
        id = "itemId";
      }
      if (item[id] == row[id]) {
        this.editData.splice(index, 1);
      }
    });
  }
  // 清空数据
  resetData() {
    this.editData = [];
    this.addData = [];
  }
  changeCell(event, row, key, type, code) {
    console.log(row);
  }

  //全部选中/全部不选中
  checkedAll(status) {
    this.CheckedRowArray = [];
    let _this = this;
    this.editData.forEach(function (item, index) { 
      _this.$set(item, _this.chKey, status);
      if (status) {
        _this.CheckedRowArray.push(item);
      }
    });
  }
  getCheckedAll(){
    return this.CheckedRowArray
  }
  //选中传入Ids行
  checkedRows(Ids, status) {
    if (typeof Ids == "number") {
      Ids = [Ids.toString()];
    } else if (typeof Ids == "string") {
      Ids = Ids.split(",");
      // for (let index = 0; index < Ids.length; index++) {
      //   Ids[index] = parseInt(Ids[index]);
      // }
    }
    this.checkedRowsFun(this.editData, Ids, status);
  }
  checkedRowsFun(data, Ids, status) {
    let _this = this;
    data.forEach(function (item, index) {
      let id = "id";
      if (item.Id != undefined) {
        id = "Id";
      }
      if (item.itemId != undefined) {
        id = "itemId";
      }
      if (Ids.indexOf(item[id].toString()) >= 0) {
        _this.$set(item, _this.chKey, status);
        if (status) {
          if (!_this.isRepeatCheckedRow(item)) {
            _this.CheckedRowArray.push(item);
          }
        } else {
          _this.CheckedRowArray.splice(_this.getIndexBySelId(item[id]), 1);
        }
        _this.$emit("on-check", item, _this.CheckedRowArray);
      }
    });
  }

  //判断已经被选中的行有无重复
  isRepeatCheckedRow(row) {
    let id = "id";
    if (row.Id != undefined) {
      id = "Id";
    }
    if (row.itemId != undefined) {
      id = "itemId";
    }
    let repeat = false;
    this.CheckedRowArray.forEach(function (item, index) {
      let id2 = "id";
      if (item.Id != undefined) {
        id2 = "Id";
      }
      if (item.itemId != undefined) {
        id2 = "itemId";
      }
      if (row[id] == item[id2]) {
        repeat = true;
        return;
      }
    });
    return repeat;
  }
  //获取指定Id在已选中的数据中的下标
  getIndexBySelId(Id) {
    let returnIndex = -1;
    this.CheckedRowArray.forEach(function (item, index) {
      let id2 = "id";
      if (item.Id != undefined) {
        id2 = "Id";
      }
      if (item.itemId != undefined) {
        id2 = "itemId";
      }
      if (Id == item[id2]) {
        returnIndex = index;
        return;
      }
    });
    return returnIndex;
  }
}
